import React, {useState} from "react";
import {Col} from "antd";
import {
    CompanyFilter,
    SubCompanyFilter,
    SearchText,
    CodPaymentRefCodeStatusFilter
} from "../../_defaultComponents/FilterComponents";

export const CodPastPeriodsPageFilters = ({
    filters,
    setFilters,
    isFromCustomerTheme = true,
    loading
}) => {
    const [fromCustomerTheme] = useState(isFromCustomerTheme);
    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.referenceCode}
                    onChange={value => setFilters({...filters, referenceCode: value.toUpperCase()})}
                    label="Referans Fatura No"
                    showLabel={true}
                    loading={loading}
                />
            </Col>
            {!fromCustomerTheme && (
                <>
                    <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                        <CompanyFilter
                            value={filters.companyId}
                            onChange={value =>
                                setFilters({...filters, companyId: value, subcompanyId: undefined})
                            }
                            allowClear={true}
                            loading={loading}
                            disabled={loading}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                        <SubCompanyFilter
                            value={filters.subcompanyId}
                            onChange={value => setFilters({...filters, subcompanyId: value})}
                            company={filters.companyId}
                            showSearch={true}
                            allowClear={true}
                            showAllOption={false}
                            loading={loading}
                            disabled={loading}
                        />
                    </Col>
                </>
            )}
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CodPaymentRefCodeStatusFilter
                    value={filters.referenceCodeStatus}
                    onChange={value => setFilters({...filters, referenceCodeStatus: value})}
                    loading={loading}
                    disabled={loading}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.orderNumber}
                    onChange={value => setFilters({...filters, orderNumber: value})}
                    label="Sipariş No"
                    showLabel={true}
                    loading={loading}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.receiverName}
                    onChange={value => setFilters({...filters, receiverName: value})}
                    label="Müşteri Adı / Fiş No"
                    showLabel={true}
                    loading={loading}
                />
            </Col>
        </React.Fragment>
    );
};
